<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Additional Task Request</b-navbar-brand>
        </b-navbar>

        <banner-component :allModuleIdBanner="
            this.$sessionsStorage.get('allModuleIdMain')
              ? this.$sessionsStorage.get('allModuleIdMain')
              : ''
          " :jobSeriesBanner="
            this.$sessionsStorage.get('JOBSERIES')
              ? this.$sessionsStorage.get('JOBSERIES')
              : ''
          " iconId="fa fa-ship" />
        <!-- :bannerClientName="ImportDetail.clientName ? ImportDetail.clientName : ''" -->
        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- <div
                class="mt-4"
                v-if="
                  (ADDTaskDetail.expenseId != '' && accounts == false) ||
                  (ADDTaskDetail.expenseId != '' && role == 'Admin')
                "
              > <input
                  :id="'revcheckbox'"
                  name="checkbox-1"
                  type="checkbox"
                  v-model="ADDTaskDetail.revisedMail"
                  @click="RevisedAss('revcheckbox')"
                  value="1"
                  unchecked-value="0"
                />
                <span class="error">Send Revised Expenses Request</span>
              </div> -->

              <b-card class="mt-2">
                <h5>
                  <b-badge variant="info">Assignment Details</b-badge>
                </h5>
                <table id="otherAdditionalTask" class="table table-bordered table-sm gutr mt-1 mb-1">
                  <tbody>
                    <tr>
                      <th>Job No.</th>
                      <th>Job Date</th>
                      <th>Client Name</th>
                      <th>POD</th>
                    </tr>

                    <tr v-for="(item, index) in assignmentData" :key="index">
                      <td class="error" style="font-size: 14px">
                        <h6>{{ item.Job_Series }}</h6>
                      </td>
                      <td class="error" style="font-size: 14px">
                        <h6>{{ item.JobDate }}</h6>
                      </td>
                      <td class="error" style="font-size: 14px">
                        <h6>{{ item.clientName }}</h6>
                      </td>
                      <td class="error" style="font-size: 14px">
                        <h6>{{ item.POD }}</h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h5>
                  <b-badge variant="info">Additional Task Details</b-badge>
                </h5>
                <table class="table table-sm table-bordered gutr mt-1 mb-1">
                  <tbody style="background: white">
                    <tr>
                      <th scope="col">SN.</th>
                      <th scope="col">Particulars</th>
                      <th scope="col">Exp Amount</th>
                      <th scope="col">Bill To Customer</th>
                      <th scope="col">Selling AMT</th>
                      <th scope="col">Remarks</th>
                      <!-- <th scope="col">Payment Status</th> -->
                      <th scope="col">
                        Action
                        <b-button id="show-btn" size="sm" variant="primary" :disabled="
                            assignmentData[0].Job_Series !=
                            $sessionsStorage.get('JOBSERIES')
                              ? true
                              : false
                          " @click="addInvArry">
                          Add <i class="fa fa-plus" aria-hidden="true"></i></b-button>
                      </th>
                    </tr>
                    <tr v-for="(itm, idx) in lineADDTaskModalArray" :key="idx">
                      <th scope="row">{{ idx + 1 }}</th>
                      <td>
                        <model-list-select :isDisabled="itm.expenseId != '' ? true : false" :list="ledgerData"
                          v-model="itm.addTask_ledgerId" option-value="ledgerId" option-text="ledger"
                          placeholder="Select "></model-list-select>
                        <span class="error" v-if="itm.addTask_ledgerId_err">{{
                          itm.addTask_ledgerId_err
                          }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="itm.expenseId != '' ? true : false" :formatter="capitalizeAll"
                          id="amount" name="amount" v-model="itm.addTask_amount"></b-form-input>
                        <span class="error" v-if="itm.addTask_amount_err">{{
                          itm.addTask_amount_err
                          }}</span>
                      </td>
                      <td>
                        <!-- {{ itm }} -->
                        <b-form-radio-group v-model="itm.addTask_scCategory" :options="SCCategoryList" class="mb-3"
                          value-field="SCVal" text-field="SCText" @input="
                            chnageSCCategoryList(
                              itm.addTask_scCategory,
                              itm.addTask_scCategory_err,
                              itm.addTask_selling_amt,
                              itm.addTask_selling_amt_err,
                              lineADDTaskModalArray,
                              idx,
                              itm
                            )
                          "></b-form-radio-group>
                        <span class="error" v-if="
                            (itm.addTask_scCategory == '' ||
                              itm.addTask_scCategory == null ||
                              itm.addTask_scCategory == undefined) &&
                            itm.addTask_scCategory_err != ''
                          ">{{ itm.addTask_scCategory_err }}</span>
                      </td>
                      <td>
                        <!-- :disabled="itm.expenseId != '' && itm.addTask_selling_amt ? true : false" -->
                        <!-- itm.expenseId != '' && itm.addTask_selling_amt -->
                        <b-form-input v-if="itm.addTask_scCategory == 'Yes'" :formatter="capitalizeAll" id="amount"
                          name="amount" @wheel="handleWheel" type="number" @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)" v-model="itm.addTask_selling_amt"></b-form-input>
                        <span class="error" v-if="itm.addTask_selling_amt_err">{{
                          itm.addTask_selling_amt_err
                          }}</span>
                        <span v-else-if="itm.addTask_scCategory == 'No'">No</span>
                      </td>

                      <td>
                        <b-form-textarea :disabled="itm.expenseId != '' ? true : false" :formatter="capitalizeAll"
                          id="remark" name="remark" v-model="itm.addTask_remark"></b-form-textarea>
                        <span class="error" v-if="itm.addTask_remark_err">{{
                          itm.addTask_remark_err
                          }}</span>
                      </td>
                      <!-- <td>
                        <model-list-select
                          :list="statusList"
                          v-model="itm.addTask_payStatus"
                          option-value="payVal"
                          option-text="payText"
                          placeholder="Select "
                        ></model-list-select>
                        <span class="error" v-if="itm.addTask_payStatus_err">{{
                    itm.addTask_payStatus_err
                  }}</span>
                      </td> -->
                      <td>
                        <b-button :disabled="itm.expenseId != '' ? true : false" class="ml-auto" id="show-btn" size="sm"
                          variant="danger" @click="removeInvArry(idx)">
                          <!-- v-if="idx != 0" -->
                          Remove
                          <i class="fa fa-minus" aria-hidden="true"></i></b-button>
                        <b-button v-if="
                            $sessionsStorage.get('designation') == 'Admin' &&
                            $sessionsStorage.get('nameUser') == 'Bhavneesh' && itm.expenseId
                          " class="ml-auto" id="show-btn" size="sm" variant="danger"
                          @click="removeAdditionalTask(itm)">
                          <!-- v-if="idx != 0" -->
                          Remove Admin
                          <i class="fa fa-minus" aria-hidden="true"></i></b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-card>
              <b-row>
                <b-col lg="5"></b-col>
                <b-col lg="2"><b-button v-if="lineADDTaskModalArray.length > 0" class="mt-3" size="sm" variant="primary"
                    id="addButtonLoaderSB" @click="addADDTaskDetail" :disabled="
                      assignmentData[0].Job_Series != $sessionsStorage.get('JOBSERIES')
                        ? true
                        : false
                    ">Save & Submit
                  </b-button>

                  <md-spinner md-indeterminate id="loaderSB" style="display: none"></md-spinner>
                </b-col>
                <b-col lg="5"></b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>

        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok"
          ref="popMailAfter"></md-dialog-confirm>

        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import BannerComponent from "./bannerComponent.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import Multiselect from "vue-multiselect";

import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";
export default {
  // props: ["allModuleId", "JOBSERIES"],
  beforeMount() {
    if (
      this.$sessionsStorage.get("allModuleIdMain") != undefined &&
      this.$sessionsStorage.get("JOBSERIES") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/allModule/AdditionalTask");
      if (this.$sessionsStorage.get("allModuleIdMain")) {
        this.getData();
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },

  data() {
    return {
      assignmentData: [],
      assign_no_series: this.$sessionsStorage.get("JOBSERIES"),
      allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
      selectDateFormat,
      accounts: false,
      // accounts: globalPermissionStatus("Accounts"),
      componentKey: 0,
      revisedADDTaskDetails: [],
      items: [],
      lastSelectItem: {},
      ledgerData: ["gfdg"],
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      statusList: [
        {
          payVal: "1",
          payText: "PENDING",
        },
        {
          payVal: "2",
          payText: "COMPLETED",
        },
      ],
      currList: [
        {
          payVal: "INR",
          payText: "INR",
        },
        {
          payVal: "USD",
          payText: "USD",
        },
      ],
      showAlgo: false,
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ADDTaskDetail: {
        revisedMail: "0",
        expenseId: "",
        allModuleId: "",
        addTask_ledgerId: "",
        addTask_amount: "",
        addTask_remark: "",
        addTask_scCategory: "",
        addTask_selling_amt: "",
        addTask_payStatus: "",
        userId: "",

        paymentMode: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
      },
      SCCategoryList: [
        {
          SCVal: "Yes",
          SCText: "Yes",
          // notEnabled: true,
        },
        {
          SCVal: "No",
          SCText: "No",
          // notEnabled: true,
        },
      ],

      permissionStatus: true,
      ADDTaskDetailArray: [],
      showMoreSB: false,

      role: this.$sessionsStorage.get("designation"),
      nextPageType: "",
      lineADDTaskModalArray: [],
      validateINV: true,
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    MultiSelect,
    // Loading,
    CustomLoader,
    BannerComponent,
    Multiselect,
  },
  computed: {
    disableSave() {
      return this.accounts == false &&
        this.role != "Admin" &&
        !this.ADDTaskDetail.expenseId
        ? true
        : false;
    },
    ADDTaskDetailArrayList() {
      return this.ADDTaskDetailArray;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
    CheckValueNumbers(item, arr) {
      if (!isNaN(item)) {
        if (Number.isInteger(item)) {
        }
      } else {
        this.alert.content = "Please Enter Only Integer and Decimal Values";
        this.$refs["addPop"].open();
      }
    },
    handleWheel(event) {
      // Prevent scrolling while the input is focused
      if (document.activeElement === event.target) {
        event.preventDefault();
      }
    },
    chnageSCCategoryList(
      addTask_scCategory,
      addTask_scCategory_err,
      addTask_selling_amt,
      addTask_selling_amt_err,
      lineADDTaskModalArray,
      idx,
      itm
    ) {
      console.log("addTask_scCategory=>", addTask_scCategory);
      console.log("idx=>", idx);

      itm.addTask_scCategory = addTask_scCategory;
      itm.addTask_scCategory = addTask_selling_amt;
      this.lineADDTaskModalArray[idx].addTask_scCategory = addTask_scCategory;
      this.lineADDTaskModalArray[idx].addTask_scCategory_err = "";
      this.lineADDTaskModalArray[idx].addTask_selling_amt = addTask_selling_amt;
      this.lineADDTaskModalArray[idx].addTask_selling_amt_err = "";
      console.log("lineADDTaskModalArray=>", this.lineADDTaskModalArray);
    },
    onSelectPaymentMode(event, item) {
      // console.log(event,item)
      // item.
      this.$forceUpdate();
    },
    onSelectPaymentStatus(event, item) {
      this.$forceUpdate();
    },
    onChoosePaymentDate(event, item) {
      this.$forceUpdate();
    },
    onChooseInvoiceDate(event, item) {
      this.$forceUpdate();
    },
    onSelectionChange(event) {
      console.log("Events= > ", event);
    },
    // deselect option
    reset() {
      this.items = []; // reset
    },
    // select option from parent component
    selectFromParentComponent() {
      this.items = _.unionWith(this.items, [this.options[0]], _.isEqual);
      console.log("Item =>", this.items);
    },
    addInvArry() {
      console.log("Add Additional Task");

      let obj = {
        expenseId: "",
        allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
        addTask_ledgerId: "",
        addTask_amount: "",
        addTask_remark: "",
        addTask_scCategory: "",
        addTask_selling_amt: "",
        addTask_payStatus: "",

        addTask_ledgerId_err: "",
        addTask_amount_err: "",
        addTask_remark_err: "",
        addTask_scCategory_err: "",
        addTask_selling_amt_err: "",
        addTask_payStatus_err: "",
      };
      this.lineADDTaskModalArray.push(obj);

      console.log(this.lineADDTaskModalArray.length);
    },

    RevisedAss(id) {
      // alert(id);
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        (this.items = []), (this.lastSelectItem = {});
        for (let i = 0; i < lineADDTaskModalArray.length; i++) {
          this.lineADDTaskModalArray[i].addTask_ledgerId = "";
          this.lineADDTaskModalArray[i].addTask_amount = "";
          this.lineADDTaskModalArray[i].addTask_remark = "";
          this.lineADDTaskModalArray[i].addTask_scCategory = "";
          this.lineADDTaskModalArray[i].addTask_selling_amt = "";
          this.lineADDTaskModalArray[i].addTask_payStatus = "";
        }
      }
    },

    addRevisedADDTask(index, id) {
      var checkBox = document.getElementById(id).checked;
      console.log("Id => " + id + " : " + checkBox);
      if (checkBox) {
        this.revisedADDTaskDetails.push(this.lineADDTaskModalArray[index]);
        this.lineADDTaskModalArray[index].addTask_ledgerId = "";
        this.lineADDTaskModalArray[index].addTask_amount = "";
        this.lineADDTaskModalArray[index].addTask_remark = "";
        this.lineADDTaskModalArray[index].addTask_scCategory = "";
        this.lineADDTaskModalArray[index].addTask_selling_amt = "";
        this.lineADDTaskModalArray[index].addTask_payStatus = "";
      } else {
        this.revisedADDTaskDetails.splice(index, 1);
      }

      console.log("Revised mail => ", this.revisedADDTaskDetails);
    },

    removeInvArry(index) {
      this.lineADDTaskModalArray.splice(index, 1);
    },

    removeAdditionalTask(item) {
      this.itemObj = item;

      this.itemObj.is_delete = this.itemObj.is_delete == "1" ? 0 : 1;
      let paylod = {
        tableName: "all_expenses",
        tableId: "expenseId",
        tableIsActive: "is_delete",
        value1: this.itemObj.is_delete,
        tableVal: item.expenseId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on Proforma Error: ", error);
        });
    },

    getDueDate() {
      var date = new Date(this.ADDTaskDetail.sobDate);
      console.log(date);
      if (this.ImportDetail.shippingId == "15") {
        this.ADDTaskDetail.dueDate = date.setDate(date.getDate() + 9);
        this.ADDTaskDetail.dueDate = new Date(this.ADDTaskDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "8") {
        this.ADDTaskDetail.dueDate = date.setDate(date.getDate() + 9);
        this.ADDTaskDetail.dueDate = new Date(this.ADDTaskDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "13") {
        this.ADDTaskDetail.dueDate = date.setDate(date.getDate() + 9);
        this.ADDTaskDetail.dueDate = new Date(this.ADDTaskDetail.dueDate);
      } else if (this.ImportDetail.shippingId == "27") {
        this.ADDTaskDetail.dueDate = date.setDate(date.getDate() + 13);
        this.ADDTaskDetail.dueDate = new Date(this.ADDTaskDetail.dueDate);
      } else {
        this.ADDTaskDetail.dueDate = date.setDate(date.getDate() + 6);
        this.ADDTaskDetail.dueDate = new Date(this.ADDTaskDetail.dueDate);
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
    },

    validateADDTaskDetail() {
      let validate_new = true;
      let i = 0;
      let errCount = 0;
      let MainARR = this.lineADDTaskModalArray;
      for (let j = 0; j < MainARR.length; j++) {
        if (this.accounts != false) {
          if (MainARR[j].addTask_ledgerId != "") {
            if (MainARR[j].addTask_payStatus == "") {
              this.lineADDTaskModalArray[j]["addTask_payStatus_err"] =
                "Payment Status Field is Required";
              validate_new = false;
              ++errCount;
              break;
            } else {
              this.lineADDTaskModalArray[j]["addTask_payStatus_err"] = "";
              validate_new = true;
            }
          }
        } else if (this.accounts == false || this.role == "Admin") {
          if (MainARR[j].addTask_ledgerId == "") {
            this.lineADDTaskModalArray[j]["addTask_ledgerId_err"] =
              "Particulars Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDTaskModalArray[j]["addTask_ledgerId_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addTask_amount == "") {
            this.lineADDTaskModalArray[j]["addTask_amount_err"] =
              "Amount Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDTaskModalArray[j]["addTask_amount_err"] = "";
            validate_new = true;
          }

          if (MainARR[j].addTask_scCategory == "") {
            this.lineADDTaskModalArray[j]["addTask_scCategory_err"] =
              "Bill to Customer Field is Required";
            validate_new = false;
            ++errCount;
            break;
          } else {
            this.lineADDTaskModalArray[j]["addTask_scCategory_err"] = "";
            validate_new = true;
          }
        }
      }
      console.log("this.lineADDTaskModalArray=>", this.lineADDTaskModalArray);

      if (errCount > 0) {
        this.validateINV = false;
      }
      if (validate_new == false) {
        this.validateINV = false;
      } else {
        this.validateINV = true;
      }
    },

    addADDTaskDetail() {
      this.validateADDTaskDetail();
      if (this.validateINV == false) {
        this.alert.content = "PLEASE ENTER ALL DETAILS.";
        this.$refs["addPop"].open();
        return false;
      }
      this.ADDTaskDetail.salesExeuctionNo = this.$sessionsStorage.get("JOBSERIES");
      this.ADDTaskDetail.allModuleId = this.$sessionsStorage.get("allModuleIdMain");

      this.ADDTaskDetail.TaskDetails = this.lineADDTaskModalArray;

      if (this.revisedADDTaskDetails.length > 0) {
        this.ADDTaskDetail.revisedADDTaskDetails = this.revisedADDTaskDetails;
      }
      console.log("After => ", this.ADDTaskDetail);
      // return false
      if (this.validateINV != false) {
        $("#addButtonLoaderSB").css("display", "none");
        $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Expenses/addAllAdditionTask.php`,
          data: JSON.stringify(this.ADDTaskDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              $("#loaderSB").css("display", "none");
              $("#addButtonLoaderSB").css("display", "block");
              window.history.go(-1);
              this.alert.content = data.msg;
              if (data.msg == "Inserted Successfully") {
                // this.alert.content = "Data Added Successfully";
              } else {
                // this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
            }
          })
          .catch((error) => {});
      }
    },
    ParticularFilter(list, query) {
      return this.ledgerData.filter((x) => {
        return x.ledger.toLowerCase().includes(query.toLowerCase());
      });
    },
    getData() {
      this.lineADDTaskModalArray=[];
      this.doLoading();
      let new_data = {
        allModuleId: this.$sessionsStorage.get("allModuleIdMain"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Expenses/getAdditionalTaskDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            // this.ledgerData = [];
            console.log("MyDataArr=>", data);
            console.log("Priyanshu Singh=>", data.mainAdditionalTaskData);
            if (data.assignmentData.length > 0) {
              this.assignmentData = data.assignmentData;
            }
            if (data.mainAdditionalTaskData.length > 0) {
              // Object.keys(this.lineADDTaskModalArray).map((x) => {
              //   this.lineADDTaskModalArray[x] = data.mainAdditionalTaskData[0][x] || "";
              // });
              // this.ADDTaskDetailArray = data.mainAdditionalTaskData;

              let i = 0;
              data.mainAdditionalTaskData.forEach((element) => {
                this.ADDTaskDetail.expenseId = element.expenseId || "";
                element["expenseId"] = element.expenseId || "";
                element["allModuleId"] = element.allModuleId || "";
                element["addTask_ledgerId"] = element.ledgerId || "";
                element["addTask_amount"] = element.amount || "";
                element["addTask_remark"] = element.remark || "";
                element["addTask_scCategory"] = element.scCategory || "";
                element["addTask_selling_amt"] = element.selling_amt || "";
                // element["addTask_payStatus"] = element.addTask_payStatus || "";

                // if (element.expenseId == "")
                //   element["PaymentStatusFlag"] = true;
                // else element["PaymentStatusFlag"] = false;

                // onSelectVendor(i,element,element.vendor)
                this.lineADDTaskModalArray.push(element);
                i++;
              });
              this.ADDTaskDetail.revisedMail = 0;
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },

    // JqueryFun() {
    //   return $(function() {
    //     return $("#ccContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// AdditionalTask.vue?78564ff8